import type { ReactNode } from 'react';
import { Card } from '@/components/ui/Card';

/**
 * Marco común del login y del registro: tarjeta blanca, título, explicación y pie con el
 * enlace para cambiar de pantalla.
 *
 * Vive aquí (y no en `components/layout/`) porque es chrome del formulario, no del shell: el
 * `PublicLayout` ya pone el fondo, el logo y centra el contenido; esto solo da forma a la
 * tarjeta. Se limita a `max-w-md` (el layout permite 2xl) para que la línea de texto no se
 * estire en escritorio; en móvil ocupa el ancho disponible con el `px-4` del layout.
 */

export interface AuthCardProps {
  title: string;
  description: string;
  children: ReactNode;
  /** Enlace del pie ("¿No tienes cuenta? …"). */
  footer?: ReactNode;
}

export function AuthCard({ title, description, children, footer }: AuthCardProps) {
  return (
    <Card className="mx-auto w-full max-w-md p-6 sm:p-7">
      <h1 className="text-page font-semibold text-ink">{title}</h1>
      <p className="mt-1.5 text-caption text-ink-muted">{description}</p>

      <div className="mt-6">{children}</div>

      {footer ? (
        <p className="mt-6 border-t border-line pt-4 text-center text-caption text-ink-muted">
          {footer}
        </p>
      ) : null}
    </Card>
  );
}
